import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import './App.css';
import axios from 'axios';
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import FISelection from "./components/FISelection";
import Overview from "./components/Overview";
import Tokens from "./components/Tokens";
import RefreshTokens from "./components/RefreshTokens";
import Redirect from "./components/Redirect";
import EnvSelection from "./components/EnvSelection";
import ProtectedRoute from "./components/ProtectedRoute";
import {Button, Header, Modal} from "semantic-ui-react";
import Login from "./components/Login";
import Transactions from "./components/Transactions";
import Error from "./components/Error";
import Details from "./components/Details";
import Smartlink from "./components/Smartlink";
// import { withCookies } from 'react-cookie';

axios.interceptors.response.use(function (response) {
    if (response.status === 401 || response.status === 403) {
        window.location = "/login";
    }
    return response;
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403){
        window.location = "/login";
    }
});

class App extends Component {

    state = {
        env: "dev",
        redirect: "/",
        open: false,
        isAuth: false,
        toggle: false
    };

    handleChange = (e, { name, value }) => {
        localStorage.setItem("env", value);
        this.setState({env: value});
        window.location.reload();
    };

    envUpdate = (e) => {
        this.setState({env: e});
    };

    revokeToken = () => {
        axios.get("/csrf")
            .then(tokenResp => {
                let config = {
                    headers: {
                        'X-CSRF-TOKEN': tokenResp.data.token,
                    }
                }
                axios.delete("/api/token/" + localStorage.getItem("env"), config).then(res => {
                    if (res.status === 200 && res.data) {
                        this.close();
                        window.location.href = '/home';
                    } else {
                        console.log("error canceling service: " + res.data);
                        this.close();
                        alert("error canceling service: " + res.data);
                    }
                }).catch(err => {
                    console.log(err);
                    this.close();
                    alert("error canceling service");
                })
            })
    };



    show = () => this.setState({open: true});

    close = () => this.setState({open: false, pending: false, error: false, userClosed: false});

    updateAuth = (auth) => this.setState({isAuth: auth});

    compUpdate = () => this.setState({toggle: !this.state.toggle});

    constructor(props) {
        super(props);
        // const { cookies } = props;
        // this.state.csrfToken = cookies.get("XSRF-TOKEN")
    }

    render() {
        const { env, open, isAuth } = this.state;
        let currentPath = window.location.pathname;
        let storedEnv = localStorage.getItem("env");

        if (!storedEnv) storedEnv = env;

        return (
            <div>
                {currentPath !== "/tokens" && currentPath !== "/login" &&
                <div className={currentPath === '/' ? 'hooli-hero' : 'hooli-nav hooli-nav-blue'}>
                    <Route render={props => <Nav isHome={currentPath === '/'} isAuth={isAuth} updateAuth={this.updateAuth} show={this.show} />} />
                    <Switch>
                        <ProtectedRoute
                            exact={true}
                            path='/'
                            comp={<Hero isAuth={isAuth} updateAuth={this.updateAuth} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                    </Switch>
                </div>
                }
                <div className='hooli-nav hooli-pad'>
                    <Switch>
                        <Route path="/login" render={props => <Login />} />
                        <Route path="/err" render={props => <Error />} />
                        <ProtectedRoute
                            path='/account-select'
                            comp={<FISelection isAuth={isAuth} updateAuth={this.updateAuth} env={storedEnv} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/smartlink'
                            comp={<Smartlink isAuth={isAuth} updateAuth={this.updateAuth} env={storedEnv} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/home'
                            comp={<Overview isAuth={isAuth} updateAuth={this.updateAuth} env={storedEnv} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/tokens'
                            comp={<Tokens isAuth={isAuth} updateAuth={this.updateAuth} env={storedEnv} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/refreshTokens'
                            comp={<RefreshTokens isAuth={isAuth} updateAuth={this.updateAuth} env={storedEnv} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/details'
                            comp={<Details env={storedEnv} compUpdate={this.compUpdate} />}
                            checkSession={this.checkSession}
                            updateAuth={this.updateAuth}
                            login={this.login}
                            isAuth={isAuth} />
                        <ProtectedRoute
                            path='/redirect'
                            comp={<Redirect envUpdate={this.envUpdate} />}
                            checkSession={this.checkSession}
                            login={this.login}
                            isAuth={isAuth} />
                        {currentPath !== "/" && currentPath !== "/logout" &&
                            <ProtectedRoute
                                comp={<Error />}
                                checkSession={this.checkSession}
                                login={this.login}
                                isAuth={isAuth} />
                        }
                    </Switch>
                </div>

                <div className='hooli-btn-group hooli-centered'>
                    <Modal
                        className='hooli-centered hooli-modal'
                        centered={true}
                        open={open}
                        closeOnEscape={false}
                        closeOnDimmerClick={true}
                        dimmer='blurring'
                        size='tiny'>
                        <Modal.Content>
                            <Header as='h1' className='hooli-modal-header'>Cancel Service</Header>
                            <div className='hooli-modal-content'>Are you sure you would like to cancel your service?</div>
                            <div className='hooli-modal-content'>This will remove all of your current linked accounts.</div>
                            <div className='hooli-btn-group'>
                                <Button className='hooli-btn-select' onClick={this.revokeToken}>Yes</Button>
                                <Button className='hooli-btn-primary-inverted' onClick={this.close}>No</Button>
                            </div>
                        </Modal.Content>
                    </Modal>
                </div>
                {currentPath !== "/tokens" && currentPath !== "/login" && currentPath !== "/err" &&
                    <div className={'akoya-footer'}>
                        <EnvSelection currentEnv={storedEnv} onChange={this.handleChange} />
                    </div>
                }
            </div>
        );
    }
}

// export default withCookies(App);
export default App;
